import * as THREE from "three";

export interface LoomViewerCandidate<T> {
  readonly group: THREE.Group;
  readonly value: T;
}

export function buildLoomViewerCandidate<T>(
  build: (group: THREE.Group) => T,
  dispose: (object: THREE.Object3D) => void,
): LoomViewerCandidate<T> {
  const group = new THREE.Group();
  group.name = "Loom off-scene candidate";
  try {
    return { group, value: build(group) };
  } catch (error) {
    dispose(group);
    throw error;
  }
}

export function commitLoomViewerCandidate(
  target: THREE.Group,
  candidate: THREE.Group,
  dispose: (object: THREE.Object3D) => void,
): void {
  const previous = [...target.children];
  const replacement = [...candidate.children];
  replacement.forEach((child) => target.add(child));
  previous.forEach((child) => {
    target.remove(child);
    dispose(child);
  });
}
